import type React from "react";
import { ClickOutsideWrapper } from "app/custom-hooks/useClickOutside";
import { PopupTargetContainer } from "./styledComponents";

interface IPopupTarget {
    children: React.ReactNode;
    isOpen: boolean;
    renderPopup: Function;
    closeFn: () => void;
}

export const PopupTarget: React.FC<IPopupTarget> = ({ children, isOpen, renderPopup, closeFn }) => (
    <PopupTargetContainer>
        {children}
        {isOpen ? <ClickOutsideWrapper onClickOutside={closeFn}>{renderPopup()}</ClickOutsideWrapper> : null}
    </PopupTargetContainer>
);
